window.addEventListener('DOMContentLoaded', () => {
  const $searchButton = document.querySelector('.cmp-header__search-button');
  const $searchForm = document.querySelector('.cmp-header__search-form');
  const $closeButton = document.querySelector(
    '.cmp-header__search-form .search-clear button'
  );
  const $searchInput = document.querySelector<HTMLInputElement>(
    '.cmp-header__search-form .search-field input'
  );
  const $submitButton = document.querySelector(
    '.cmp-header__search-form .suggestions button'
  );

  const toggleSearchForm = () => {
    $searchButton?.classList.toggle('cmp-header__search-button--active');
    $searchForm?.classList.toggle('cmp-header__search-form--visible');
  };

  const toggleSearchSubmit = () => {
    $submitButton?.toggleAttribute(
      'disabled',
      $searchInput?.value.trim() === ''
    );
  };

  $searchButton?.addEventListener('click', () => {
    toggleSearchForm();
  });

  $closeButton?.addEventListener('click', () => {
    toggleSearchForm();
  });

  $searchInput?.addEventListener('input', () => {
    toggleSearchSubmit();
  });
  toggleSearchSubmit();
});
